import reporteexclusiones from "@/locales/languages/es_MX/view/reportes/reporteexclusiones";
import reporteusuarios from "@/locales/languages/es_MX/view/reportes/reporteusuarios";
import reportevisitas from "@/locales/languages/es_MX/view/reportes/reportevisitas";

export default { reporteexclusiones, reporteusuarios, reportevisitas };



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/reportes/index.js